import { render } from "./progressBar.vue?vue&type=template&id=bc574590"
import script from "./progressBar.vue?vue&type=script&lang=js"
export * from "./progressBar.vue?vue&type=script&lang=js"

import "./progressBar.vue?vue&type=style&index=0&id=bc574590&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__